import { render } from "./AutoVerificationServices.vue?vue&type=template&id=ee06ba54"
import script from "./AutoVerificationServices.vue?vue&type=script&lang=js"
export * from "./AutoVerificationServices.vue?vue&type=script&lang=js"

import "./AutoVerificationServices.vue?vue&type=style&index=0&id=ee06ba54&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__